import { createContext } from 'react';

import { CompanyContext, ZoneZipContext } from '../Company.slice';

export type ZipZoneSelectComponentProps = {
  onCompanySwitchConfirmed: (companyId: string) => void;
  companyContext: CompanyContext;
  zoneZipContext: ZoneZipContext | undefined;
};

export type ZipZoneSelectComponentType = React.FunctionComponent<ZipZoneSelectComponentProps>;

/**
 * Each provider has different business rules for the CompanyZoneZipSelect component, handle them in each
 * application directory and use this context to provide it to the CompanySelected component
 */
export const ZipZoneSelectContext = createContext<ZipZoneSelectComponentType | null>(null);
